/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get_inline_address } from "../../utils/data";
import { formatTime, STATUS_COLOR } from "../utils";

import StatusPill from "../../shared/components/StatusPill.vue";

const __vue_script__ = {
  name: "StopListItem",
  components: { StatusPill },
  props: ["stop", "editable"],
  emits: ["selected"],
  data() {
    return {
      show: false,
      statusColor: STATUS_COLOR,
    };
  },
  mounted() {},
  computed: {
    hasDO() {
      return (
        this.stop.document === "Inventory Movement Validation" &&
        this.stop.delivery_note
      );
    },
    doctype() {
      if (this.hasDO) {
        return "Delivery Note";
      }
      return this.stop.document;
    },
    docname() {
      if (this.hasDO) {
        return this.stop.delivery_note;
      }
      return this.stop.document_name;
    },
    anchorClass() {
      return {
        "list-group-item-light": this.stop.status !== "Planned",
        disabled: !this.editable,
      };
    },
  },
  methods: {
    formatTime: formatTime,
    formatAddress(address) {
      return get_inline_address(address);
    },
  },
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "list-group" }, [
    _c(
      "a",
      {
        staticClass: "list-group-item list-group-item-action",
        class: _vm.anchorClass,
        attrs: { href: "#" },
        on: {
          click: function($event) {
            return _vm.$emit("selected")
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-wrap w-100 justify-content-between align-items-center"
          },
          [
            _c("label", [
              _c("small", [_vm._v(_vm._s(_vm.doctype))]),
              _vm._v(" "),
              _c("h5", { staticClass: "mb-1" }, [_vm._v(_vm._s(_vm.docname))])
            ]),
            _vm._v(" "),
            _c("status-pill", {
              attrs: {
                colors: _vm.statusColor,
                status: _vm.stop.status,
                doctype: _vm.stop.doctype
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mb-3" }, [
          _c("span", { staticClass: "indicator-pill whitespace-nowrap blue" }, [
            _c("span", [_vm._v(_vm._s(_vm.stop.type))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-sm-flex flex-wrap" }, [
          _c("div", { staticClass: "flex-1 px-3" }, [
            _c("label", [
              _c("small", [_vm._v("Planned Time: ")]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.formatTime(_vm.stop.planned_time)))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex-1 px-3" }, [
            _c("p", { staticClass: "mb-1" }, [
              _c("strong", [_vm._v(_vm._s(_vm.stop.party))])
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "mb-1",
              domProps: { innerHTML: _vm._s(_vm.stop.address_display) }
            })
          ])
        ])
      ]
    )
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-00fc19ae_0", { source: "\n.card-header[data-v-00fc19ae] {\n  cursor: pointer;\n}\n.flex-1[data-v-00fc19ae] {\n  flex: 1;\n}\nlabel > small[data-v-00fc19ae] {\n  font-weight: bold;\n}\n", map: {"version":3,"sources":["../mesrajaya/mesrajaya/public/js/delivery_trip_web/components/StopListItem.vue"],"names":[],"mappings":";AAmGA;EACA,eAAA;AACA;AAEA;EACA,OAAA;AACA;AAEA;EACA,iBAAA;AACA","file":"StopListItem.vue","sourcesContent":["<template>\n  <div class=\"list-group\">\n    <a\n      href=\"#\"\n      class=\"list-group-item list-group-item-action\"\n      :class=\"anchorClass\"\n      @click=\"$emit('selected')\"\n    >\n      <div\n        class=\"d-flex flex-wrap w-100 justify-content-between align-items-center\"\n      >\n        <label>\n          <small>{{ doctype }}</small>\n          <h5 class=\"mb-1\">{{ docname }}</h5>\n        </label>\n        <status-pill\n          :colors=\"statusColor\"\n          :status=\"stop.status\"\n          :doctype=\"stop.doctype\"\n        />\n      </div>\n\n      <div class=\"mb-3\">\n        <span class=\"indicator-pill whitespace-nowrap blue\">\n          <span>{{ stop.type }}</span>\n        </span>\n      </div>\n\n      <div class=\"d-sm-flex flex-wrap\">\n        <div class=\"flex-1 px-3\">\n          <label>\n            <small>Planned Time: </small>\n            <p>{{ formatTime(stop.planned_time) }}</p>\n          </label>\n        </div>\n        <div class=\"flex-1 px-3\">\n          <p class=\"mb-1\">\n            <strong>{{ stop.party }}</strong>\n          </p>\n          <p class=\"mb-1\" v-html=\"stop.address_display\"></p>\n        </div>\n      </div>\n    </a>\n  </div>\n</template>\n<script>\nimport { get_inline_address } from \"../../utils/data\";\nimport { formatTime, STATUS_COLOR } from \"../utils\";\n\nimport StatusPill from \"../../shared/components/StatusPill.vue\";\n\nexport default {\n  name: \"StopListItem\",\n  components: { StatusPill },\n  props: [\"stop\", \"editable\"],\n  emits: [\"selected\"],\n  data() {\n    return {\n      show: false,\n      statusColor: STATUS_COLOR,\n    };\n  },\n  mounted() {},\n  computed: {\n    hasDO() {\n      return (\n        this.stop.document === \"Inventory Movement Validation\" &&\n        this.stop.delivery_note\n      );\n    },\n    doctype() {\n      if (this.hasDO) {\n        return \"Delivery Note\";\n      }\n      return this.stop.document;\n    },\n    docname() {\n      if (this.hasDO) {\n        return this.stop.delivery_note;\n      }\n      return this.stop.document_name;\n    },\n    anchorClass() {\n      return {\n        \"list-group-item-light\": this.stop.status !== \"Planned\",\n        disabled: !this.editable,\n      };\n    },\n  },\n  methods: {\n    formatTime: formatTime,\n    formatAddress(address) {\n      return get_inline_address(address);\n    },\n  },\n};\n</script>\n\n<style scoped>\n.card-header {\n  cursor: pointer;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\nlabel > small {\n  font-weight: bold;\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-00fc19ae"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../mesrajaya/mesrajaya/public/js/delivery_trip_web/components/StopListItem.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__